/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Receiver
 */
export interface Receiver {
    /**
     * The role name
     * @type {string}
     * @memberof Receiver
     */
    roleName: string;
    /**
     * The email address of the signer
     * @type {string}
     * @memberof Receiver
     */
    email: string;
    /**
     * The full name of the signer
     * @type {string}
     * @memberof Receiver
     */
    name: string;
    /**
     * The routing order of the signer (lower means earlier) determines the order of deliveries to the recipients
     *       Parallel routing order is supported by using the same integer as the order for two or more recipients.
     * @type {number}
     * @memberof Receiver
     */
    routingOrder: number;
}

/**
 * Check if a given object implements the Receiver interface.
 */
export function instanceOfReceiver(value: object): boolean {
    if (!('roleName' in value)) return false;
    if (!('email' in value)) return false;
    if (!('name' in value)) return false;
    if (!('routingOrder' in value)) return false;
    return true;
}

export function ReceiverFromJSON(json: any): Receiver {
    return ReceiverFromJSONTyped(json, false);
}

export function ReceiverFromJSONTyped(json: any, ignoreDiscriminator: boolean): Receiver {
    if (json == null) {
        return json;
    }
    return {
        
        'roleName': json['roleName'],
        'email': json['email'],
        'name': json['name'],
        'routingOrder': json['routingOrder'],
    };
}

export function ReceiverToJSON(value?: Receiver | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'roleName': value['roleName'],
        'email': value['email'],
        'name': value['name'],
        'routingOrder': value['routingOrder'],
    };
}

